import { FC } from 'react';

import { FormTabs } from 'components';
import { Stack } from 'libs/ui';
import { ClientMainInfo } from 'modules/client/common/components/ClientMainInfo';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { LegalRepresentativeSectionsProps } from './types';
import { useLegalRepresentativeSections } from './useLegalRepresentativeSections';

export const LegalRepresentativeSections: FC<
  LegalRepresentativeSectionsProps
> = ({ countryRiskAt, ...props }) => {
  const { tabs, info } = useLegalRepresentativeSections(props);

  return (
    <CountryRiskProvider
      at={countryRiskAt}
      role={CountryRiskRole.LegalClientRepresentative}
    >
      <Stack spacing={36}>
        {info && <ClientMainInfo info={info} />}
        <FormTabs tabs={tabs} />
      </Stack>
    </CountryRiskProvider>
  );
};
